import React, { useState, useRef } from 'react';
import { useApp } from '../context/AppContext';
import ProductForm from '../components/ProductForm';
import { fmt } from '../utils/igv';

export default function ConfigPage() {
  const [tab, setTab] = useState('prods');
  return (
    <div style={S.wrap}>
      <div style={S.hdr}>
        <h2 style={S.title}>⚙️ Configuración</h2>
      </div>
      <div style={S.tabs}>
        <button style={{ ...S.tab, ...(tab === 'prods' ? S.tabOn : {}) }} onClick={() => setTab('prods')}>📦 Productos</button>
        <button style={{ ...S.tab, ...(tab === 'cats'  ? S.tabOn : {}) }} onClick={() => setTab('cats')}>🏷️ Categorías</button>
        <button style={{ ...S.tab, ...(tab === 'store' ? S.tabOn : {}) }} onClick={() => setTab('store')}>🏪 Tienda</button>
      </div>
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        {tab === 'prods' && <ProductsTab/>}
        {tab === 'cats'  && <CategoriesTab/>}
        {tab === 'store' && <StoreTab/>}
      </div>
    </div>
  );
}

/* ════════════════════════════ PRODUCTS TAB ════════════════════════════ */
function ProductsTab() {
  const { products, categories, deleteProduct } = useApp();
  const [search, setSearch]         = useState('');
  const [editing, setEditing]       = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);

  const filtered = search.trim()
    ? products.filter(p => p.name?.toLowerCase().includes(search.toLowerCase()) || p.barcode?.includes(search) || categories.find(c=>c.id===p.category_id)?.name?.toLowerCase().includes(search.toLowerCase()))
    : products;

  const handleDelete = async () => {
    await deleteProduct(confirmDel.id);
    setConfirmDel(null);
    setEditing(null);
  };

  return (
    <div style={S.tabContent}>
      <div style={S.saRow}>
        <input style={S.searchInp} value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Buscar producto..."/>
        <button style={S.addBtn} onClick={() => setEditing('new')}>+ Nuevo</button>
      </div>

      <div style={S.list}>
        {filtered.length === 0
          ? <p style={S.noRes}>Sin productos</p>
          : filtered.map(p => {
              const low = p.stock <= (p.min_stock || 5);
              const cat = categories.find(c => c.id === p.category_id);
              return (
                <div key={p.id} style={S.prodRow} onClick={() => setEditing(p)}>
                  <div style={S.prodThumb}>
                    {p.image_url
                      ? <img src={p.image_url} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:8 }}/>
                      : <span style={{ fontSize: 22 }}>{p.emoji || '📦'}</span>
                    }
                  </div>
                  <div style={S.prodInfo}>
                    <p style={S.prodName}>{p.name}</p>
                    <p style={S.prodMeta}>{cat?.emoji} {cat?.name} · {p.barcode || 'Sin código'}</p>
                  </div>
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <p style={S.prodPrice}>{fmt(p.price)}</p>
                    <p style={{ fontSize: 10, color: low ? 'var(--err)' : 'var(--t2)' }}>{p.stock} {p.unit}{low ? ' ⚠' : ''}</p>
                  </div>
                  <span style={S.rowArr}>›</span>
                </div>
              );
            })
        }
      </div>

      {editing && (
        <ProductForm
          product={editing === 'new' ? null : editing}
          onClose={() => setEditing(null)}
        />
      )}

      {confirmDel && (
        <ConfirmModal
          title="¿Eliminar producto?"
          msg={`"${confirmDel.name}" será eliminado permanentemente.`}
          onCancel={() => setConfirmDel(null)}
          onConfirm={handleDelete}
        />
      )}
    </div>
  );
}

/* ════════════════════════════ CATEGORIES TAB ════════════════════════════ */
function CategoriesTab() {
  const { categories, products, createCategory, updateCategory, deleteCategory } = useApp();
  const fileRef    = useRef();
  const [editCat,   setEditCat]   = useState(null);
  const [cfmDel,    setCfmDel]    = useState(null);
  const [ecName,    setEcName]    = useState('');
  const [ecImage,   setEcImage]   = useState('');
  const [ecErr,     setEcErr]     = useState('');
  const [uploading, setUploading] = useState(false);

  const openEdit = (cat) => {
    setEditCat(cat);
    setEcName(cat === 'new' ? '' : cat.name);
    setEcImage(cat === 'new' ? '' : (cat.image_url || ''));
    setEcErr('');
  };

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5e6) { alert('Imagen muy grande (max 5MB)'); return; }
    const reader = new FileReader();
    reader.onload = ev => setEcImage(ev.target.result);
    reader.readAsDataURL(file);
    setUploading(true);
    try {
      const form = new FormData();
      form.append('image', file);
      const res  = await fetch('/api/upload-image', { method: 'POST', body: form });
      const data = await res.json();
      setEcImage(data.image_url);
    } catch (_) { /* queda el base64 del preview */ }
    finally { setUploading(false); }
  };

  const handleSave = async () => {
    if (!ecName.trim()) { setEcErr('Nombre requerido'); return; }
    const data = {
      name:      ecName.trim(),
      emoji:     '🏷️',
      image_url: ecImage || '',
    };
    if (editCat === 'new') await createCategory(data);
    else await updateCategory(editCat.id, data);
    setEditCat(null);
  };

  const handleDelete = async () => {
    await deleteCategory(cfmDel.id);
    setCfmDel(null);
  };

  const listCats = categories.filter(c => c.id !== 'all');

  return (
    <div style={S.tabContent}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button style={S.addBtn} onClick={() => openEdit('new')}>+ Nueva categoría</button>
      </div>

      <div style={S.list}>
        {listCats.map(c => {
          const count = products.filter(p => p.category_id === c.id).length;
          return (
            <div key={c.id} style={S.catRow}>
              <div style={S.catBall}>
                {c.image_url
                  ? <img src={c.image_url} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:12 }}/>
                  : <span style={{ fontSize:22 }}>{c.emoji || '🏷️'}</span>
                }
              </div>
              <div style={{ flex: 1 }}>
                <p style={S.catName}>{c.name}</p>
                <p style={S.catCount}>{count} producto{count !== 1 ? 's' : ''}</p>
              </div>
              <button style={S.catEditBtn} onClick={() => openEdit(c)}>✏️ Editar</button>
              <button style={S.catDelBtn}  onClick={() => setCfmDel(c)}>🗑</button>
            </div>
          );
        })}
      </div>

      {/* Category edit sheet */}
      {editCat && (
        <div style={S.sheetBg}>
          <div style={S.sheet}>
            <p style={S.sheetTitle}>{editCat === 'new' ? 'Nueva categoría' : 'Editar categoría'}</p>

            {/* Imagen */}
            <input ref={fileRef} type="file" accept="image/*" hidden onChange={handleFile}/>
            <div
              onClick={() => fileRef.current.click()}
              style={{ width:'100%', height:130, background:'var(--bg2)', borderRadius:14, border:'1.5px dashed var(--bd2)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', cursor:'pointer', marginBottom:14, overflow:'hidden', position:'relative' }}>
              {uploading
                ? <p style={{ fontSize:13, color:'var(--t1)' }}>Subiendo imagen...</p>
                : ecImage
                  ? <img src={ecImage} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                  : <>
                      <span style={{ fontSize:32, marginBottom:6 }}>📷</span>
                      <p style={{ fontSize:12, color:'var(--t1)' }}>Toca para subir imagen</p>
                      <p style={{ fontSize:10, color:'var(--t2)', marginTop:2 }}>Galería o cámara</p>
                    </>
              }
              {ecImage && !uploading && (
                <div style={{ position:'absolute', bottom:6, right:8, background:'rgba(0,0,0,.6)', borderRadius:7, padding:'3px 8px', fontSize:11, color:'#fff' }}>
                  📷 Cambiar
                </div>
              )}
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={S.fldLbl}>Nombre</label>
              <input style={{ ...S.fldInp, ...(ecErr ? { borderColor: 'var(--err)' } : {}) }}
                value={ecName} onChange={e => { setEcName(e.target.value); setEcErr(''); }}
                placeholder="Ej: Gaseosas, Licores..."/>
              {ecErr && <span style={{ fontSize: 11, color: 'var(--err)', display: 'block', marginTop: 3 }}>{ecErr}</span>}
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              <button style={S.cancelBtn} onClick={() => setEditCat(null)}>Cancelar</button>
              <button style={S.saveBtn} disabled={uploading} onClick={handleSave}>
                {uploading ? 'Subiendo...' : '✓ Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {cfmDel && (
        <ConfirmModal
          title="¿Eliminar categoría?"
          msg={`"${cfmDel.name}"${products.filter(p=>p.category_id===cfmDel.id).length > 0 ? ` tiene ${products.filter(p=>p.category_id===cfmDel.id).length} producto(s). Se moverán a "Otros".` : ''}`}
          onCancel={() => setCfmDel(null)}
          onConfirm={handleDelete}
        />
      )}
    </div>
  );
}

/* ════════════════════════════ STORE TAB ════════════════════════════ */
function StoreTab() {
  const { settings, saveSettings, products, notify } = useApp();
  const [f, setF]           = useState({ ...settings });
  const [saving, setSaving] = useState(false);

  const set = k => e => setF(p => ({ ...p, [k]: e.target.value }));

  const handleSave = async () => {
    setSaving(true);
    await saveSettings(f);
    setSaving(false);
  };

  const exportJSON = () => {
    const blob = new Blob([JSON.stringify({ products, exportDate: new Date().toISOString() }, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `inventario-${new Date().toISOString().slice(0,10)}.json`; a.click();
    URL.revokeObjectURL(url);
    notify('Datos exportados ✓');
  };

  return (
    <div style={S.tabContent}>
      <Fld label="Nombre de la tienda"><input style={S.fldInp} value={f.store_name||''} onChange={set('store_name')} placeholder="MINIMARKET"/></Fld>
      <Fld label="Dirección"><input style={S.fldInp} value={f.store_address||''} onChange={set('store_address')} placeholder="Arequipa, Perú"/></Fld>
      <Fld label="RUC (opcional)"><input style={S.fldInp} value={f.ruc||''} onChange={set('ruc')} placeholder="20123456789" maxLength={11}/></Fld>
      <Fld label="Nombre del cajero"><input style={S.fldInp} value={f.cashier||''} onChange={set('cashier')} placeholder="Tu nombre"/></Fld>

      <button style={S.saveBtn} onClick={handleSave} disabled={saving}>{saving ? 'Guardando...' : '✓ Guardar cambios'}</button>

      <div style={{ marginTop: 20, background: 'var(--bg2)', borderRadius: 12, border: '0.5px solid var(--bd2)', overflow: 'hidden' }}>
        <button style={S.actionRow} onClick={exportJSON}>
          <span style={{ fontSize: 20 }}>⬇️</span>
          <div style={{ flex: 1, textAlign: 'left' }}>
            <p style={{ fontSize: 14, fontWeight: 500 }}>Exportar inventario</p>
            <p style={{ fontSize: 12, color: 'var(--t2)' }}>{products.length} productos en JSON</p>
          </div>
          <span style={{ color: 'var(--t2)' }}>›</span>
        </button>
      </div>

      <div style={{ marginTop: 16, background: 'var(--bg2)', borderRadius: 12, padding: 14, border: '0.5px solid var(--bd2)', fontSize: 12, color: 'var(--t1)', lineHeight: 1.7 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 6 }}>
          <p style={{ fontWeight: 700, color: 'var(--t0)', fontSize: 14 }}>Inventario Pro — Minimarket</p>
          <span style={{ background:'var(--acc)', color:'#fff', borderRadius:8, padding:'3px 10px', fontSize:12, fontWeight:800 }}>v1.2.0</span>
        </div>
        <p>PWA + Node.js + SQLite</p>
        <p>Los precios incluyen IGV 18%. El comprobante desglosa automáticamente operaciones gravadas + IGV + total.</p>
      </div>
    </div>
  );
}

/* ── Shared helpers ── */
function Fld({ label, children }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <label style={S.fldLbl}>{label}</label>
      {children}
    </div>
  );
}

function ConfirmModal({ title, msg, onCancel, onConfirm }) {
  return (
    <div style={S.cfmBg}>
      <div style={S.cfmBox}>
        <p style={S.cfmTitle}>{title}</p>
        <p style={S.cfmMsg}>{msg}</p>
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={S.cancelBtn} onClick={onCancel}>Cancelar</button>
          <button style={{ ...S.saveBtn, background: 'var(--err)' }} onClick={onConfirm}>Eliminar</button>
        </div>
      </div>
    </div>
  );
}

const S = {
  wrap:       { display: 'flex', flexDirection: 'column', height: '100%' },
  hdr:        { padding: '14px 14px 0', flexShrink: 0 },
  title:      { fontSize: 20, fontWeight: 800 },
  tabs:       { display: 'flex', gap: 6, padding: '10px 14px 0', flexShrink: 0 },
  tab:        { flex: 1, padding: '8px 4px', background: 'var(--bg2)', border: '0.5px solid var(--bd2)', borderRadius: 10, fontSize: 11, fontWeight: 600, color: 'var(--t1)', textAlign: 'center' },
  tabOn:      { background: 'rgba(232,67,90,.15)', borderColor: 'var(--acc)', color: 'var(--acc)' },
  tabContent: { flex: 1, overflowY: 'auto', padding: '12px 14px 80px', scrollbarWidth: 'none' },
  saRow:      { display: 'flex', gap: 8, marginBottom: 12 },
  searchInp:  { flex: 1, background: 'var(--bg2)', border: '0.5px solid var(--bd2)', borderRadius: 10, padding: '9px 12px', color: 'var(--t0)', fontSize: 12 },
  addBtn:     { background: 'var(--acc)', color: '#fff', border: 'none', borderRadius: 10, padding: '9px 14px', fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap' },
  list:       { scrollbarWidth: 'none' },
  noRes:      { textAlign: 'center', padding: '30px 0', color: 'var(--t2)', fontSize: 13 },
  prodRow:    { display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: '0.5px solid var(--bd)', cursor: 'pointer' },
  prodThumb:  { width: 44, height: 44, borderRadius: 8, background: 'var(--bg3)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' },
  prodInfo:   { flex: 1, minWidth: 0 },
  prodName:   { fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  prodMeta:   { fontSize: 10, color: 'var(--t2)', marginTop: 1 },
  prodPrice:  { fontSize: 13, fontWeight: 800, color: 'var(--acc)' },
  rowArr:     { fontSize: 16, color: 'var(--t2)' },
  catRow:     { display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: '0.5px solid var(--bd)' },
  catBall:    { width: 44, height: 44, borderRadius: 12, background: 'var(--bg3)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0, overflow: 'hidden' },
  catName:    { fontSize: 13, fontWeight: 600 },
  catCount:   { fontSize: 10, color: 'var(--t2)', marginTop: 1 },
  catEditBtn: { background: 'var(--bg2)', border: '0.5px solid var(--bd2)', borderRadius: 7, padding: '5px 9px', fontSize: 11, color: 'var(--t1)', flexShrink: 0 },
  catDelBtn:  { background: 'rgba(231,76,60,.1)', border: '0.5px solid rgba(231,76,60,.2)', borderRadius: 7, padding: '5px 8px', fontSize: 13, flexShrink: 0 },
  sheetBg:    { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.82)', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', zIndex: 100 },
  sheet:      { background: 'var(--bg1)', borderRadius: '20px 20px 0 0', padding: '16px 16px 24px' },
  sheetTitle: { fontSize: 15, fontWeight: 700, marginBottom: 12 },
  fldLbl:     { display: 'block', fontSize: 10, color: 'var(--t1)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: .4, marginBottom: 4 },
  fldInp:     { width: '100%', background: 'var(--bg2)', border: '0.5px solid var(--bd2)', borderRadius: 9, padding: '9px 12px', color: 'var(--t0)', fontSize: 13 },
  saveBtn:    { width: '100%', background: 'var(--acc)', color: '#fff', border: 'none', borderRadius: 10, padding: 12, fontSize: 14, fontWeight: 700, marginTop: 4 },
  cancelBtn:  { flex: 1, background: 'var(--bg2)', color: 'var(--t1)', border: '0.5px solid var(--bd)', borderRadius: 10, padding: 11, fontSize: 13 },
  actionRow:  { width: '100%', display: 'flex', alignItems: 'center', gap: 12, padding: '13px 14px', background: 'none', border: 'none', borderBottom: '0.5px solid var(--bd)', color: 'var(--t0)' },
  cfmBg:      { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.82)', display: 'flex', alignItems: 'center', padding: 24, zIndex: 200 },
  cfmBox:     { background: 'var(--bg1)', borderRadius: 16, padding: 22, width: '100%', border: '0.5px solid var(--bd2)' },
  cfmTitle:   { fontSize: 16, fontWeight: 700, marginBottom: 6 },
  cfmMsg:     { fontSize: 13, color: 'var(--t1)', marginBottom: 20 },
};
